const WebsocketTokenMap = new class WebsocketTokenMap {
    tokens = {};

    set(channelName, token) {
        this.tokens[channelName] = token;

        return this;
    }

    get(channelName) {
        return this.tokens[channelName] ?? null;
    }

    has(channelName) {
        return this.tokens.hasOwnProperty(channelName);
    }

    remove(channelName) {
        this.tokens.delete(channelName);

        return this;
    }
};

function useWebsocketTokenMap() {
    return WebsocketTokenMap;
}

export {useWebsocketTokenMap};
